/**
 * Tabs Content — Tab switching (desktop sidebar / mobile drill-down) + Accordion
 */
(function () {
  'use strict';

  document.querySelectorAll('.le-tabs-content').forEach(function (section) {
    var tabs = section.querySelectorAll('.le-tabs-content__tab');
    var panels = section.querySelectorAll('.le-tabs-content__panel');
    var backBtn = section.querySelector('.le-tabs-content__back');

    // Ensure panel-open is NOT set on page load (in case of cached state)
    section.classList.remove('le-tabs-content--panel-open');

    function switchPanel(target) {
      tabs.forEach(function (t) { t.classList.remove('le-tabs-content__tab--active'); });
      panels.forEach(function (p) { p.classList.remove('le-tabs-content__panel--active'); });

      var activeTab = section.querySelector('[data-tab="' + target + '"]');
      if (activeTab) activeTab.classList.add('le-tabs-content__tab--active');

      var panel = section.querySelector('[data-panel="' + target + '"]');
      if (panel) panel.classList.add('le-tabs-content__panel--active');
    }

    // Tab click — switch panel + open drill-down on mobile
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        switchPanel(tab.getAttribute('data-tab'));
        section.classList.add('le-tabs-content--panel-open');
      });
    });

    // Back button (mobile) — close drill-down
    if (backBtn) {
      backBtn.addEventListener('click', function () {
        section.classList.remove('le-tabs-content--panel-open');
      });
    }

    // Accordion
    section.querySelectorAll('.le-tabs-content__accordion-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.closest('.le-tabs-content__accordion').classList.toggle('le-tabs-content__accordion--open');
      });
    });
  });
})();
